import { lazy } from 'react';
import { Activity } from 'lucide-react';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { RouteErrorBoundary } from '@/components/shared/RouteErrorBoundary';
import { ModuleEnabledGate } from '../ModuleEnabledGate';
import type { ModuleFrontendDefinition } from '../types';
import {
  MODULE_BASE_PATH,
  MODULE_ID,
  MODULE_PERMISSION,
} from './manifest';

const NetworkStatusPage = lazy(() => import('./pages/NetworkStatusPage'));
const NetworkStatusWidget = lazy(() => import('./components/NetworkStatusWidget'));

/**
 * Network Status Widget — frontend module definition. Contribution points only.
 * The route is wrapped in the standard ProtectedRoute (permission) +
 * ModuleEnabledGate (runtime flag) + a scoped error boundary so a fault renders
 * a local fallback instead of white-screening the app.
 */
const definition: ModuleFrontendDefinition = {
  id: MODULE_ID,

  routes: [
    {
      path: MODULE_BASE_PATH,
      element: (
        <ProtectedRoute permission={MODULE_PERMISSION as never}>
          <ModuleEnabledGate id={MODULE_ID}>
            <RouteErrorBoundary>
              <NetworkStatusPage />
            </RouteErrorBoundary>
          </ModuleEnabledGate>
        </ProtectedRoute>
      ),
    },
  ],

  nav: [
    {
      labelKey: 'module_network_status_widget:nav.title',
      path: MODULE_BASE_PATH,
      icon: Activity,
      permission: MODULE_PERMISSION,
      group: 'operations',
    },
  ],

  dashboardWidgets: [
    {
      id: MODULE_ID,
      permission: MODULE_PERMISSION,
      component: NetworkStatusWidget,
    },
  ],
};

export default definition;
